<template>
  <div id="app">
    <!--<router-link to="/Home" id="router"></router-link>-->
    <router-view></router-view>

  </div>
</template>

<script>
import Vuex from 'vuex'
import { mapGetters } from 'vuex'

export default {
  name: 'App',
  mounted() {
    /*setTimeout(function() {
      document.getElementById('router').click();
    },500)*/
  }
}
</script>

<style>
@import url("https://www.w3schools.com/w3css/4/w3.css");
* {
  font-family: "微軟正黑體";
  font-weight: bolder;
  background-color: #444444;
}
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: white;
}
</style>


// WEBPACK FOOTER //
// src/App.vue